import React from 'react'
import ReactDOM from 'react-dom/client'
import { UserProvider } from './store/user_context.jsx';
import Social_login from "./auth/service";
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './store/app_context.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <UserProvider>
                <AppProvider>
                    <Social_login />
                </AppProvider>
            </UserProvider>
        </BrowserRouter>
    </React.StrictMode>
)
